import {
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES,
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS,
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE,
  COMPANIES_HOUSE_UK_GET_OFFICERS,
  COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS,
  COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE,
} from "./actionType";

const initialState = {
  loading: false,
  companies: [],
  filingHistory: [],
  officers: [],
  error: "",
};

const CompaniesHouseGovUK = (state = initialState, action) => {
  switch (action.type) {
    case COMPANIES_HOUSE_UK_SEARCH_COMPANIES:
      return {
        ...state,
        loading: true,
      };
    case COMPANIES_HOUSE_UK_SEARCH_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: action.payload,
        error: "",
      };
    case COMPANIES_HOUSE_UK_SEARCH_COMPANIES_FAILURE:
      return {
        ...state,
        loading: false,
        companies: [],
        error: action.payload,
      };
    case COMPANIES_HOUSE_UK_GET_FILING_HISTORY:
      return {
        ...state,
        loading: true,
      };
    case COMPANIES_HOUSE_UK_GET_FILING_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        filingHistory: action.payload,
        error: "",
      };
    case COMPANIES_HOUSE_UK_GET_FILING_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        filingHistory: [],
        error: action.payload,
      };
    case COMPANIES_HOUSE_UK_GET_OFFICERS:
      return {
        ...state,
        loading: true,
      };
    case COMPANIES_HOUSE_UK_GET_OFFICERS_SUCCESS:
      return {
        ...state,
        loading: false,
        officers: action.payload,
        error: "",
      };
    case COMPANIES_HOUSE_UK_GET_OFFICERS_FAILURE:
      return {
        ...state,
        loading: false,
        officers: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default CompaniesHouseGovUK;
